import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function CountdownBar() {
  const {
    formatted,
    isExpired
  } = useCountdown(14 * 60 + 37);
  return <div className="sticky top-0 z-50 border-b border-ink-line bg-ink text-cream" data-id="element-16" data-mp="2ve0gv39xdht1">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-2.5 sm:justify-center sm:gap-6 sm:px-6 sm:py-3" data-id="element-17" data-mp="2re9sf67vfdro">
        <p className="flex items-start gap-2 text-[10px] font-medium uppercase leading-tight tracking-[0.1em] text-cream/80 sm:items-center sm:text-xs" data-id="element-18" data-mp="2mforf4ksoq26">
          <AlertTriangleIcon aria-hidden="true" className="mt-px h-3.5 w-3.5 shrink-0 text-champagne sm:h-4 sm:w-4" data-id="element-19" data-mp="2cfo5davjjvua" />
          <span data-id="element-20" data-mp="28fnpdlssncl4">
            Los 5 bonos se eliminan cuando el contador llegue a cero
          </span>
        </p>
        <p className="shrink-0 font-sans text-sm font-semibold tabular-nums text-champagne-light sm:text-base" aria-live="polite" data-id="element-21" data-mp="anjdu0hyf0k3">
          <span className="sr-only" data-id="element-22" data-mp="6leq1ie6sy5d">Tiempo restante: </span>
          {isExpired ? '00:00:00' : formatted}
        </p>
      </div>
    </div>;
}